import type { OpenBalanceResponse } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";

export const OPEN_BALANCE_QUERY_KEY = "open-balance" as const;

export function openBalanceQueryKey(userId: number, billingDateYmd: string) {
  return [QueryKeys.Balance, OPEN_BALANCE_QUERY_KEY, userId, billingDateYmd] as const;
}

export function sumOpenBalanceTotal(
  items: OpenBalanceResponse[] | null | undefined,
): number {
  if (!items?.length) return 0;
  return items.reduce((sum, item) => sum + Number(item.totalAmount ?? 0), 0);
}

/** Balance due for admin statement summary (studio today, via open-balance API). */
export function sumStatementBalanceDue(
  items: OpenBalanceResponse[] | null | undefined,
  studentId?: number | null,
): number {
  if (!items?.length) return 0;
  if (studentId != null && studentId > 0) {
    return items
      .filter((row) => row.studentId === studentId)
      .reduce((sum, item) => sum + Number(item.totalAmount ?? 0), 0);
  }
  return sumOpenBalanceTotal(items);
}

export function owingOpenBalanceRows(
  items: OpenBalanceResponse[] | null | undefined,
): OpenBalanceResponse[] {
  if (!items?.length) return [];
  return items.filter((row) => Number(row.totalAmount ?? 0) > 0);
}

/** Per-student split is only useful when the family has more than one child. */
export function shouldShowOpenBalanceBreakdown(
  familyStudentCount: number,
  owingStudentCount: number,
): boolean {
  return familyStudentCount > 1 && owingStudentCount > 0;
}
